import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";

//Components
import { Timezone } from '../../../../../../components/uiControls'
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import { Button } from '@gpstrackit/gtc-react-controls';
import { Typography } from "@mui/material";

//Actions
import { openWarningConfirmResolveModal } from 'Redux/actions'
import { closeWarningResolveModal } from './redux/slice';

//Styles
import './resolve.scss';
import DOMPurify from "dompurify";
const Resolve = (props) => {
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const { loading, data, open } = useSelector(state => state.warningsResolveRedux);
    const dateformat = useSelector(state => state.securityRedux.user.dateformat);
    const loadingUserLanguage = useSelector(state => state.commomRedux.loadingUserLanguage);

    const timeFromDate = (date, language = 'en') => {
        moment.locale(language);
        const dateMoment = moment(date);
        const timeElapsed = dateMoment.fromNow();
        return timeElapsed;
    }

    const generateSummary = () => {
        let description = null
            try {
                let labels = localStorage.getItem("langByS3")
                labels = labels.replace('export default ', '');
                labels = JSON.parse(JSON.parse(labels));
                for (const key in labels) {
                    let warning = key.toUpperCase()
                    if (warning.includes(data?.warning.toUpperCase())) {
                        description = labels[key]
                    }
                }
            } catch (exc) { }
            if (description) {
                return (
                    <div className="container-warning-summary">
                        {
                            data?.lastEventDate &&
                            <div style={{ opacity: 0.5 }}>
                                <Timezone
                                    date={new Date(data?.lastEventDate)}
                                    dateFormat={dateformat}
                                    timeFormat="hh:mm a"
                                    timezone={data?.timezone || "UTC"}
                                    className="maintenance-warnings-date"
                                    customFormat={true}
                                    locale={locale}
                                    noWrap={false}
                                    oneControl={true}
                                />
                                <Typography className="maintenance-warnings-date">{` (${timeFromDate(data?.lastEventDate, locale)})`}</Typography>
                            </div>
                        }
                        <h2 style={{ marginTop: 10 }}>{messages[`warnings_main_${data?.warning}`] || data?.warning}</h2>
                        <div
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
                        />
                    </div>
                )
            } else {
                return (
                    <div className="container-warning-summary">
                        {
                            data?.lastEventDate &&
                            <div style={{ opacity: 0.5 }}>
                                <Timezone
                                    date={new Date(data?.lastEventDate)}
                                    dateFormat={dateformat}
                                    timeFormat="hh:mm a"
                                    timezone={data?.timezone || "UTC"}
                                    className="maintenance-warnings-date"
                                    customFormat={true}
                                    locale={locale}
                                    noWrap={false}
                                    oneControl={true}
                                />
                                <Typography className="maintenance-warnings-date">{` (${timeFromDate(data?.lastEventDate, locale)})`}</Typography>
                            </div>
                        }
                        <h2 style={{ marginTop: 10 }}>{messages[`warnings_main_${data?.warning}`] || data?.warning}</h2>
                        <div>
                            <p>{messages['warnings_main_description_comming_soon']}</p>
                        </div>
                    </div>
                )
            }
    }

    const closeModal = () => {
        dispatch(closeWarningResolveModal())
    }

    const applyChanges = () => {
        dispatch(openWarningConfirmResolveModal({ ...data, warnings: [data?.warning] }))
    }

    let summary = generateSummary();

    return (
        <Modal
            open={open}
            title={`${data?.unitLabel || messages[`warnings_main_${data?.warning}`] || data?.warning || ''}`}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading || loadingUserLanguage}
        >
            <ModalBody>
                <div style={{ padding: '10px 26px', marginBottom: 30 }}>
                    <a onClick={() => closeModal()} style={{ textDecoration: 'underline', cursor: 'pointer' }}>{messages['warnings_main_back_to_issues']}</a>
                    {
                        !loading && (
                            <>
                                {summary}
                            </>
                        )
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <div style={{ marginLeft: 5 }}>
                    <Button
                        variant='secondary'
                        onClick={() => closeModal()}
                        style={{ marginRight: 5 }}
                    >
                        {messages['warnings_main_close']}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={() => applyChanges()}
                    >
                        {messages['warnings_main_resolve']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default Resolve;